<template>
  <div id="app">
    <BarraManusa :titulopagina="titulopagina"></BarraManusa>
    <router-view />
  </div>
</template>

<script>
import BarraManusa from "@/components/BarraManusa.vue";

export default {
  name: "App",
  components: {
    BarraManusa
  },
  data() {
    return {
      titulopaginaExtendido: "Facturas electrónicas de clientes de Manusa",
      titulopagina: "eFacturas"
    };
  }
};
</script>
